/* eslint-disable */
export default {
  title: 'Mit Sprachnachr. antworten',
  customMessage: 'Benutzerdefinierte Nachricht',
  customMessagePlaceholder: 'Benutzerdefinierte Nachricht eingeben',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
